module.exports = __webpack_public_path__ + "static/media/shutterstock_337848515.79263e1c.jpg";